import {map, throttleTime} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {contractAccounts$} from './contract-accounts';
import {botTradeAccountMap$, copyTradeAccountMap$} from './all/contract-accounts-all';
import {contractPTDiscountState$, contractMarginMode$} from './contract-user';
import type {ContractAccount} from '@/types';
import type {ContractAccountMarginMode} from '@/enum';

export interface UContractAccounts {
  type: 'accounts';
  data: {
    accounts: ContractAccount[];
  };
}
export interface UContractAccountsBotTrade {
  type: 'accounts-bot-trade';
  data: Map<number, ContractAccount[]>;
}
export interface UContractAccountsCopyTrade {
  type: 'accounts-copy-trade';
  data: Map<number, ContractAccount[]>;
}

export interface UContractPTDiscountState {
  type: 'contract-pt-discount-state';
  data: {state: boolean};
}

export interface UContractMarginMode {
  type: 'contract-account-margin-mode';
  data: {mode: ContractAccountMarginMode};
}

export function subscribeContractAccount() {
  contractAccounts$
    .pipe(map<ContractAccount[], UContractAccounts>((accounts) => ({type: 'accounts', data: {accounts}})))
    .subscribe((msg) => toUiMsg$.next(msg));

  copyTradeAccountMap$
    .pipe(
      map((data) => ({type: 'accounts-copy-trade' as const, data})),
      throttleTime(500)
    )
    .subscribe((msg) => toUiMsg$.next(msg));

  botTradeAccountMap$
    .pipe(
      map((data) => ({type: 'accounts-bot-trade' as const, data})),
      throttleTime(500)
    )
    .subscribe((msg) => toUiMsg$.next(msg));

  contractMarginMode$
    .pipe(
      map<ContractAccountMarginMode, UContractMarginMode>((data) => ({
        type: 'contract-account-margin-mode',
        data: {mode: data},
      })),
      throttleTime(500)
    )
    .subscribe((msg) => toUiMsg$.next(msg));
}

export function subscribeContractPtState() {
  contractPTDiscountState$
    .pipe(map((state: boolean): UContractPTDiscountState => ({type: 'contract-pt-discount-state', data: {state}})))
    .subscribe((msg) => toUiMsg$.next(msg));
}
